import { render } from "./slide21.vue?vue&type=template&id=0dfca821&scoped=true"
import script from "./slide21.vue?vue&type=script&lang=js"
export * from "./slide21.vue?vue&type=script&lang=js"

import "./slide21.vue?vue&type=style&index=0&id=0dfca821&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfca821"]])

export default __exports__